var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"data":{
			name: 'Invoices',
			breadcrumbs: [
				{ name: 'Home', to: '/' },
				{ name: 'Clients', to: '/clients' },
				{ name: _vm.client.name, to: '/clients/edit/' + _vm.client.id },
				{ name: 'Billings', to: '/clients/edit/' + _vm.client.id + '/billing' } ],
		}}}),_c('div',{staticClass:"actions d-flex justify-content-between mb-3"}),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mb-3"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"actions d-flex justify-content-between align-items-center"},[_c('h5',{staticClass:"p-0 m-0"},[_vm._v("Letter Notifications")])])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"})])])}]

export { render, staticRenderFns }